import React from 'react';
import { Reveal } from '../Reveal';
import type { CaseStudy } from '../../types/content';
interface ResultsBlockProps {
  results: CaseStudy['results'];
}
export function ResultsBlock({
  results
}: ResultsBlockProps) {
  return <div data-id="element-237" data-mp="1ezqulpv20p78">
      <Reveal data-id="element-238" data-mp="1f0aal11593im">
        {results.isProjected && <p className="mb-5 max-w-measure text-[13px] leading-6 text-[#6E6E6E]" data-id="element-239" data-mp="1awuh2dkdfja5">
            Projected outcomes based on the design decisions shown. This is a self-initiated concept
            project.
          </p>}
        <div className="flex flex-wrap items-center gap-3" data-id="element-240" data-mp="1jx92re18z0e6">
          <h2 id="results-title" className="text-[32px] leading-[1.1] tracking-[-0.03em] text-ink lg:text-[40px]" data-id="element-241" data-mp="1ymosqrsyf1st">
            {results.isProjected ? 'Target outcome' : 'Results'}
          </h2>
          {results.isProjected && <span className="rounded-full border border-ink px-3 py-1 text-[12px] font-medium text-ink" data-id="element-242" data-mp="27ljyk2s369vl">
              Projected, not measured
            </span>}
        </div>
        <p className="mt-6 max-w-measure text-body text-muted" data-id="element-243" data-mp="lzaj5v27u92p">{results.intro}</p>
      </Reveal>

      <dl className="mt-12 grid border-t border-hairline sm:grid-cols-2 lg:grid-cols-4" data-id="element-244" data-mp="qxc7oviev0lk">
        {results.metrics.map((metric, index) => <Reveal key={metric.label} delay={index * 0.06} data-id="element-245" data-mp="10uqee3ej8b0o" data-mpi={index}>
            <div className="flex h-full flex-col-reverse justify-end border-b border-hairline py-8 sm:pr-8" data-id="element-246" data-mp="10wb9pv8o7xzl">
              <dt className="mt-4 max-w-[22ch] text-small leading-5 text-muted" data-id="element-247" data-mp="14uir8sayl3bu">{metric.label}</dt>
              <dd className="font-serif text-[44px] leading-none tracking-[-0.04em] text-ink lg:text-[52px]" data-id="element-248" data-mp="19tlldhpehp51">
                {metric.value}
              </dd>
            </div>
          </Reveal>)}
      </dl>

      <Reveal delay={0.1} data-id="element-249" data-mp="1jnc9glhm7xk7">
        <p className="mt-10 max-w-measure text-body text-ink" data-id="element-250" data-mp="1ol461st7g7uq">{results.note}</p>
      </Reveal>
    </div>;
}